<dt-modal-content (closeClick)="dialogRef.close()" [contentPadding]="false" size="small">
  <ng-template #title></ng-template>
  <ng-template #content>
    <div class="container">
      <img src="assets/logo/dt-logo.svg" />

      <p i18n
        >Das Entscheidungsnavi ist ein Open-Source-Projekt des
        <a href="https://www.efi.rwth-aachen.de" target="_blank" rel="noopener" i18n-href>Lehrstuhls für Entscheidungsforschung</a> an der
        RWTH Aachen University und des
        <a href="https://reflektiert-entscheiden.de" target="_blank" rel="noopener">Fördervereins Reflektiert Entscheiden e.&nbsp;V.</a></p
      >

      <div class="link-row">
        <a matRipple href="https://entscheidungsnavi.de" i18n-href target="_blank" rel="noopener" i18n>Weitere Informationen</a>
        <a matRipple href="3rdpartylicenses.txt" target="_blank" rel="noopener" i18n>Open-Source-Lizenzen</a>
      </div>
    </div>
  </ng-template>
</dt-modal-content>
